<template>
  <transition name="fade">
    <div v-if="toggleModal" class="tw-fixed tw-z-[100] tw-inset-0 tw-overflow-y-auto">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-px-4">
        <div style="z-index: -1;" class="tw-fixed tw-inset-0 tw-transition-opacity">
          <div class="tw-absolute tw-inset-0 tw-bg-jrGray-60 tw-opacity-75"></div>
        </div>
        <span class="tw-hidden sm:tw-inline-block tw-align-middle sm:tw-h-screen"></span>&#8203;
        <div
          class="tw-inline-block tw-align-middle tw-bg-white tw-rounded-lg tw-text-center tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 tw-w-full lg:tw-w-1/3"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="tw-bg-white tw-p-3 tw-border tw-b-bottom">
            <p class="sm:tw-text-sm tw-text-gray-600 tw-font-medium tw-uppercase">Tipos de Habilitações
              Especiais</p>
          </div>
          <section class="modal_extra-descricao">
            <div class="menu_info">
              <span class="span_infos" v-for="(vistoria, id) in sortedInfo" :key="id">
                <section
                  class="section_menu"
                  :class="{'section_menu_selecionado' : select_info === id}"
                  @mouseover="selectInfo(id, true)"
                  @mouseup="selectInfo(id, true)"
                >
                  {{ vistoria.nm }}
                </section>
              </span>
            </div>
            <div class="desc_info">
              <span class="span_infos_desc" v-for="(vistoria, id) in sortedInfo" :key="id">
                <section
                  class="section_decricao"
                  v-show="select_info === id"
                >
                  <span>{{ vistoria.nm_alerta }}</span>
                  <span>Link para anexar o documento no cadastro:</span>
                  <a href="/usuario?pg=1#/documentos/editar-dados">Redirecionar</a>
                </section>
            </span>
            </div>
          </section>
          <div class="tw-flex tw-justify-center">
            <div class="tw-flex tw-px-3 tw-pt-2 tw-pb-2">
              <button @click.prevent="modalToggle"
                      class="tw-bg-gray-600 tw-text-white tw-px-4 tw-py-1 tw-mt-2 tw-border tw-border-gray-600 hover:tw-bg-gray-800 tw-rounded">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalHAbilitacaoExtra',
  props: ['info', 'abreFecha'],
  data() {
    return {
      select_info: null,
      toggleModal: false,
    }
  },
  methods: {
    modalToggle() {
      this.toggleModal = !this.toggleModal
    },
    selectInfo(id, value) {
      if (value) {
        this.select_info = id;
      }
    },
  },
  created() {
    if (this.sortedInfo.length > 0) {
      this.selectInfo(0, true);
    }
  },
  computed: {
    sortedInfo() {
      if (!this.info || this.info.length === 0) {
        return [];
      }

      return this.info
        .filter(item => item.nm && typeof item.nm === 'string')
        .slice()
        .sort((a, b) => a.nm.localeCompare(b.nm));
    }
  },
  watch: {
    info(newVal) {
      if (newVal && newVal.length > 0) {
        this.selectInfo(0, true);
      }
    }
  }
}
</script>

<style scoped>
.menu_info {
  width: 30%;
  cursor: pointer;
  text-align: center;
}

.desc_info {
  width: 100%;
  height: 20em;
  overflow-y: auto;
}

section.section_menu {
  width: 100%;
  background: #f2f2f2;
  padding: 15px 10px;
  border-bottom: 0.5px solid;
  font-size: 1rem !important;
  text-transform: uppercase;
}

.section_menu_selecionado {
  font-weight: 900;
  border-left: 3px solid #4b4b4b;
  color: #575757;
}

span.span_infos {
  display: flex;
  align-items: flex-start;
}

section.section_decricao {
  text-align: justify;
  padding: 5px 20px;
  width: 100%;
  height: 100%;
}

.modalHabilitacao {
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000;
  background: rgba(68, 68, 68, 0.04);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
}

.modal_extra {
  overflow: hidden;
  margin: auto;
  max-width: 650px;
  width: 50%;
  height: 50%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 4px 7px 5px rgba(141, 130, 130, 0.07);
}

.modal_extra-header {
  text-align: center;
  padding: 10px;
  color: white;
  font-weight: 800;
  background: #959595;
  border-radius: 5px 5px 0 0;
}

.section-info {
  display: flex;
  width: 100%;
  height: 84%;
  border-radius: 19px;
}

.li-titulo {
  font-size: 12px;
  display: flex;
}

ul.ul-modal-extra {
  display: flex;
  flex-direction: column;
}

li.li-titulo {
  cursor: pointer;
  width: 200px !important;
  padding: 10px 0px;
  border-bottom: 1px solid #9e9e9e;
}

li.li-titulo:hover {
  transition: 0.3s;
  border-left: 6px solid #9e9e9e;
  background: #eeebeb;
}

li.li-titulo:active {
  border-left: 6px solid #9e9e9e;
}

.activeTextModal {
  border-left: 6px solid #9e9e9e;
  background: #eeebeb;
}

section.modal_extra-descricao {
  text-align: justify;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.modal_extra-footer {
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 5px;
  color: #575757;
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  cursor: pointer;
  border-radius: 0 0 5px 5px;
  border-top: 1px solid #0000001c;
}

.modal_extra-footer:hover {
  background: rgba(171, 164, 164, 0.15);
}

@media (max-width: 551px ) {
  .modal_extra {
    margin-top: 10rem;
    width: 95%;
    height: 500px !important;
  }

  section.section_menu {
    padding: 10px;
    font-size: 10px;
  }

  .modal_extra-footer {
    width: 100%;
    padding: 0;
    font-size: 14px;
  }

  .desc_info {
    overflow: auto;
  }

  .section-info {
    height: 86%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalHAbilitacaoExtra.vue